import { SVGProps } from 'react';

const UnfoldHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16 12h6m-3-3 3 3-3 3M8 12H2m3 3-3-3 3-3m7-7v2m0 4v2m0 4v2m0 4v2"
    />
  </svg>
);
export default UnfoldHorizontal;
